import { Layout } from "antd";
import React, { useState } from "react";
import Request from "../../views/request";
import useStore from "../../store/useStore";
import { Header } from "../../components/header";
import { SideMenu } from "../../components/menu";
import VerifyEmail from "../../views/auth/VerifyEmail";
import dashboardRoutes from "../../routes/DashboardRoutes";
import BreadCrumb from "../../components/common/BreadCrumbs";
import { Redirect, Route, useLocation } from "react-router-dom";
import { ClientProvider } from "../../views/clients/ClientContext";

const { Sider, Content } = Layout;

const STANDALONE_PAGES = ["/request"];

const DashboardLayout = () => {
  const [siderCollapsed, setSiderCollapsed] = useState(false);

  const { pathname } = useLocation();

  const merchantCodeList = useStore((state) => state?.user?.merchantCodeList);
  const emailVerified = useStore((state) => state?.user?.verified ?? false);
  const menu = useStore((state) => state.menu);
 

  const index = () => {
    let redirectUrl = "/";
    const menuList = JSON.parse(localStorage.getItem("merchant-web") || null)
      ?.state?.menu;
    const code = menuList?.[0]?.code ?? "";
    const routeItem = dashboardRoutes.find((r) => r.code === code);
    if (routeItem) {
      redirectUrl = routeItem.path;
    }
    if (redirectUrl !== "/") {
      return <Redirect to={redirectUrl} />;
    }
    return <div>Нүүр хуудас</div>;
  };

  const getRoutes = () => {
    if (!emailVerified) {
      if (pathname !== "/") {
        return <Redirect to={"/"} />;
      }
      return <Route exact key="index" path="/" component={VerifyEmail} />;
    }
    if (merchantCodeList.length) {
      return [
        <Route exact key="index" path="/" component={index} />,
        ...dashboardRoutes.map((props) => {
          return (
            <Route
              exact
              key={props.code}
              path={props.path}
              render={(props) => {
                const crumbs = dashboardRoutes
                  // Get all routes that contain the current one.
                  .filter(({ path }) => props.match.path.includes(path))
                  // Swap out any dynamic routes with their param values.
                  // E.g. "/pizza/:pizzaId" will become "/pizza/1"
                  .map(({ path, ...rest }) => ({
                    path: Object.keys(props.match.params).length
                      ? Object.keys(props.match.params).reduce(
                          (path, param) =>
                            path.replace(
                              `:${param}`,
                              props.match.params[param]
                            ),
                          path
                        )
                      : path,
                    ...rest,
                  }));

                return (
                  <div className="p-8">
                    <BreadCrumb crumbs={crumbs} />
                  </div>
                );
              }}
              component={props.component}
            />
          );
        }),
      ];
    }
    if (pathname !== "/") {
      return <Redirect to={"/"} />;
    }
    return <Route exact key="index" path="/" component={Request} />;
  };

  const getIsStandalone = () => {
    // return true;
    if (!Array.isArray(merchantCodeList) || !merchantCodeList.length) {
      return false;
    }
    return !STANDALONE_PAGES.includes(pathname);
  };

  const onCollapseSider = (collapsed) => setSiderCollapsed(collapsed);

  return (
    <Layout className="layout">
      <Header />

      <ClientProvider>
        <Layout className="site-layout">
          {getIsStandalone() && (
            <Sider
              theme="light"
              collapsible
             // width={width ? `${width}px` : "250px"}
              breakpoint="sm"
              collapsedWidth={50}
              className="side-menu-sider"
              onCollapse={onCollapseSider}
            >
              <SideMenu menu={menu} collapsed={siderCollapsed} />
            </Sider>
          )}
          <Layout>
            <Content
              className="site-layout-background"
              style={{
                minHeight: 280,
                boxSizing: "border-box",
              }}
            >
              {getRoutes()}
            </Content>
          </Layout>
        </Layout>
      </ClientProvider>
    </Layout>
  );
};

export default DashboardLayout;
